export const MODALS_TYPE_MESSAGE = 'MODALS_TYPE_MESSAGE';
export const MODALS_OPEN = 'MODALS_OPEN';
export const MODALS_CLOSE = 'MODALS_CLOSE';
export const MODALS_WINDOW_RESIZE = 'MODALS_WINDOW_RESIZE';

export const defaultModalStypes = {
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    zIndex: 2000
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px',
    width: '650px'
  }
};



// WEBPACK FOOTER //
// ./src/common/modals/ModalsConstants.js